import { QueryClient } from "@tanstack/react-query";

/**
 * Heroku dynos cold-boot after a deploy or daily cycle: the first request
 * can fail or hang for ~15s while the backend wakes and re-applies schema.
 * A single retry gives up too early and the UI flashes "not found". We
 * retry several times with capped exponential backoff so a cold boot
 * resolves into a loaded board instead of an error state.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 4,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      refetchOnWindowFocus: false,
    },
  },
});
